import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
//Importo o componente de conteudo
import Globals from './Components/Miscelania/Globals';
import RequestApi from './Components/Miscelania/RequestApi';

//Importo as views

// Users
import Login from './Components/Users/Login';
import ExamsIndex from './Components/Exams/ExamsIndex';
import ExamEdit from './Components/Exams/ExamEdit';
import ExamQuestion from './Components/Exams/ExamQuestion';
import Topo from './Components/Layout/Topo';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect_url: false,
      prova: [],
      questao_selecionada: null,
      questoes_feitas: 0,
    };
  }

  render() {
    var self = this;
    return (
      <div>
          <RequestApi ref={'request_api'} />         
          <div>
            <BrowserRouter>
              <Switch>
                {/* Usuários */}
                <Route path="/provas/instrutor/login" component={Login} />
                {/* Provas */}
                <Route path="/provas/instrutor" render={(props)=>(
                  <ExamsIndex/>
                  )} />
                <Route path="/" component={Login} />
              </Switch>
            </BrowserRouter>
          </div>
      </div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js